import { z } from 'zod';
import { PickupType, WaivedFreight } from '../types/quotation.types';

export const cuttingListSchema = z
  .object({
    customerName: z.string().trim().min(1, 'Customer is required'),
    headMainOffice: z.string().trim().min(1, 'Head/Main Office is required'),
    projectCategoryId: z.string().trim().min(1, 'Project category is required'),
    projectCategoryName: z.string().nullable().optional(),
    projectName: z.string().trim().min(1, 'Project is required'),
    termsId: z.string().trim().min(1, 'Terms is required'),
    termsName: z.string().nullable().optional(),
    escalationDate: z.string().min(1, 'Escalation date is required'),
    expirationDate: z.string().min(1, 'Expiration date is required'),
    pickup: z.nativeEnum(PickupType),
    waivedFreight: z.nativeEnum(WaivedFreight),
  })
  .refine((data) => data.expirationDate >= data.escalationDate, {
    message: 'Expiration date cannot be before the escalation date',
    path: ['expirationDate'],
  });

export type CuttingListFormData = z.infer<typeof cuttingListSchema>;
